import { mapValues, isPlainObject, isFunction } from 'lodash'

const noop = () => {}

export const wrapObjectFunctions = (obj, before = noop, after, path = []) => {
  return mapValues(obj, (val, key) => {
    if (isFunction(val)) {
      const fullName = path.concat(key).join('.')
      return (...args) => {
        before(fullName, args)
        const originalResult = val(...args)
        return after ? after(fullName, originalResult) : originalResult
      }
    } else if (isPlainObject(val)) {
      path.push(key)
      const newVal = wrapObjectFunctions(val, before, after, path)
      path.pop()

      return newVal
    }

    return val
  })
}
